import { CurveMethod } from '@Types/deteriorationModels.types';

export const CURVE_METHOD_COLORS: Record<CurveMethod, string> = {
	[CurveMethod.FAILURE_DEFINITION]: '#2196F3',
	[CurveMethod.INDUSTRY_CURVE]: '#FF9800',
	[CurveMethod.CUSTOM_CURVE]: '#4CAF50',
	[CurveMethod.COPIED_CURVE]: '#9C27B0',
	[CurveMethod.ONE_EXPECTED_LIFE]: '#757575',
	[CurveMethod.UNDEFINED]: '#757575',
};

export const CHARTABLE_METHODS = [
	CurveMethod.FAILURE_DEFINITION,
	CurveMethod.INDUSTRY_CURVE,
	CurveMethod.CUSTOM_CURVE,
	CurveMethod.COPIED_CURVE,
] as const;

export const FAILURE_COUNT_THRESHOLD = 5;

// Slice used to fetch the full set of curve configs for client-side pagination on the
// configuration tab. The initial table load and every post-save refresh must use the
// same value, otherwise the refreshed list (and the derived aggregate state) can go stale.
export const ALL_CURVE_CONFIGS_SLICE = 2000;
